import { render, staticRenderFns } from "./PayProduct.vue?vue&type=template&id=bc667c1c&scoped=true"
import script from "./PayProduct.vue?vue&type=script&lang=js"
export * from "./PayProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc667c1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc667c1c')) {
      api.createRecord('bc667c1c', component.options)
    } else {
      api.reload('bc667c1c', component.options)
    }
    module.hot.accept("./PayProduct.vue?vue&type=template&id=bc667c1c&scoped=true", function () {
      api.rerender('bc667c1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/PayProduct.vue"
export default component.exports